import CoreHttp from "@/core/core-http";
import CoreUtils from "@/core/core-utils";
import CoreDate from "@/core/core-date";
import CoreLoader from "@/core/core-loader";
import CoreLocation from "@/core/core-location";
import CoreAlert from "@/core/core-alert";
import CoreAmChart from "@/core/core-amchart";
import CoreColor from "@/core/core-color";

const core = {
  http: CoreHttp,
  utils: CoreUtils,
  date: CoreDate,
  loader: CoreLoader,
  location: CoreLocation,
  alert: CoreAlert,
  color: CoreColor,
  amchart: CoreAmChart,
};

export default core;
